import api from './index'

let exports = {};

exports.getEsignBizFormById = function (params, callback) {
    api.get('/esignBizForm/getById')
        .params(params)
        .done(callback)
        .go();
};

exports.initiateEsign = function (params, callback) {
    api.post('/esignBizForm/initiateEsign')
        .data(params)
        .done(callback)
        .go()
};

exports.uploadEsignFile = function (params, callback) {
    api.get('/esignBizForm/uploadEsignFile')
        .params(params)
        .done(callback)
        .go()
};

exports.initiateEsignAgain = function (params, callback) {
    api.get('/esignBizForm/initiateEsignAgain')
        .params(params)
        .done(callback)
        .go()
};
exports.uploadEsignFileResult = function (params, callback) {
    api.get('/esignBizForm/uploadEsignFileResult')
        .params(params)
        .done(callback)
        .go()
};
exports.refreshSignFlowStatus = function (params, callback) {
    api.get('/esignBizForm/refreshSignFlowStatus')
        .params(params)
        .done(callback)
        .go()
};

// 查询企业内部印章
exports.getOrgOwnSealList = function (params, callback) {
    api.get('/esignBizForm/orgOwnSeal/list/get')
        .params(params)
        .done(callback)
        .fail(callback)
        .go();
};
// 查询被外部企业授权印章
exports.getOrgAuthorizedSealList = function (params, callback) {
    api.get('/esignBizForm/orgAuthorizedSeal/list/get')
        .params(params)
        .done(callback)
        .fail(callback)
        .go();
};
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/esignBizForm.js
// module id = 175
// module chunks = 0